import { useMemo } from "react";
import { coerce, satisfies } from "semver";
import { makeCdnUrl } from "motion-master-client";
import Icon from "./icons";

const functionBlockFwMap = [
  ["Rockwell_AOI_Demo-v1.0.zip", ">=5.6.5"],
  ["Rockwell_AOI_Demo-v1.1.zip", ">=5.6.5"]
];

function FunctionBlocks({ brandId, version }) {
  const functionBlocks = useMemo(
    () =>
      functionBlockFwMap
        .filter(([_, fwVersion]) => satisfies(coerce(version), fwVersion))
        .map(([fileName]) => ({
          fileName,
          url: makeCdnUrl(`/brands/${brandId}/function-blocks/${fileName}`),
        })),
    [version],
  );

  return functionBlocks.length ? (
    <>
      <div className="alert alert-info">
        <span className="me-2 align-text-bottom">{Icon.info}</span>
        Function blocks / libraries are available only for{" "}
        <strong>Ethernet/IP</strong> and <strong>ProfiNet</strong> fieldbus
        devices
      </div>
      <div className="list-group">
        {functionBlocks.map(({ fileName, url }) => (
          <a
            key={fileName}
            href={url}
            download={fileName}
            rel="noreferrer"
            className="list-group-item list-group-item-action d-flex align-items-center"
          >
            <span className="me-2">{Icon.download}</span>
            {fileName}
          </a>
        ))}
      </div>
    </>
  ) : (
    <p>No function blocks / libraries available for this firmware version.</p>
  );
}

export default FunctionBlocks;
